import React from 'react';

const Tab = (props) => {
    const title = props.title;
    return (

        <div className="panel">
            {props.children}
        </div>
    )
};

export default Tab;